import type {
  WorkflowStageOutDto,
  StageCreateInDto,
  StageUpdateInDto,
  StageReorderInDto,
} from 'shared/domain/workflow/types';

export interface IStageUploader {
  POST: (url: string, data: StageCreateInDto) => Promise<WorkflowStageOutDto>;
  UPDATE: (url: string, data: StageUpdateInDto) => Promise<WorkflowStageOutDto>;
  REORDER: (url: string, data: StageReorderInDto) => Promise<WorkflowStageOutDto>;
  DELETE: (url: string) => Promise<WorkflowStageOutDto>;
}

export type UploadStage = (
  uploader: IStageUploader,
  body: StageCreateInDto,
  url: string
) => Promise<WorkflowStageOutDto>;

export type UploadStageChanges = (
  uploader: IStageUploader,
  body: StageUpdateInDto,
  url: string
) => Promise<WorkflowStageOutDto>;

export type DeleteStage = (
  uploader: IStageUploader,
  url: string
) => Promise<WorkflowStageOutDto>;

export type ReorderStage = (
  uploader: IStageUploader,
  body: StageReorderInDto,
  url: string
) => Promise<WorkflowStageOutDto>;

export function uploadStage(
  uploader: IStageUploader,
  body: StageCreateInDto,
  url: string
): Promise<WorkflowStageOutDto> {
  return uploader.POST(url, body);
}

export function uploadStageChanges(
  uploader: IStageUploader,
  body: StageUpdateInDto,
  url: string
): Promise<WorkflowStageOutDto> {
  return uploader.UPDATE(url, body);
}

export function deleteStage(
  uploader: IStageUploader,
  url: string
): Promise<WorkflowStageOutDto> {
  return uploader.DELETE(url);
}

export function reorderStage(
  uploader: IStageUploader,
  body: StageReorderInDto,
  url: string
): Promise<WorkflowStageOutDto> {
  return uploader.REORDER(url, body);
}
